import * as signalR from "@microsoft/signalr";
import { store } from "@/store";
import { env } from "@/env";
import { IWorkOrder, IProductionLine } from "@/models";
import { ToastHelper } from "@/helpers/ToastHelper";

const hubUrl = `${env.api.origin}${env.api.hubPath}/workorders`;
const workOrdersHub = new signalR.HubConnectionBuilder()
    .withUrl(hubUrl, { accessTokenFactory: () => store.dispatch("user/getAccessToken")})
    .build();

workOrdersHub.on("WorkOrdersUpdated", (workOrders: IWorkOrder[]) => {
    store.commit("productionLines/WORK_ORDERS_UPDATED", workOrders);
});

workOrdersHub.on("WorkOrderUpdated", (workOrder: IWorkOrder) => {
    store.commit("productionLines/WORK_ORDER_UPDATED", workOrder);
});

workOrdersHub.on("WorkOrderStarted", (workOrder: IWorkOrder) => {
    if (store.state.user.permission.machinist || store.state.user.permission.production ||
        store.state.user.permission.outOfLine || store.state.user.permission.storage) {
        const productionLine: IProductionLine = store.getters["productionLines/getProductionLineById"](workOrder.productionLineId);
        ToastHelper.workOrders.toastWorkOrderStarted(productionLine, workOrder);
    }
});

workOrdersHub.on("WorkOrderMissionAdded", () => {
    if (store.state.user.permission.machinist || store.state.user.permission.production ||
        store.state.user.permission.outOfLine || store.state.user.permission.storage) {
        ToastHelper.workOrders.toastWorkOrderMissionAdded();
    }
});

workOrdersHub.on("WorkOrderMissionAssigned", () => {
    if (store.state.user.permission.machinist || store.state.user.permission.production ||
        store.state.user.permission.outOfLine || store.state.user.permission.storage) {
        ToastHelper.workOrders.toastWorkOrderMissionAssigned();
    }
});

workOrdersHub.on("WorkOrderMissionCanceled", () => {
    if (store.state.user.permission.machinist || store.state.user.permission.production ||
        store.state.user.permission.outOfLine || store.state.user.permission.storage) {
        ToastHelper.workOrders.toastWorkOrderMissionCanceled();
    }
});

workOrdersHub.on("WorkOrdersSynchronized", () => {
    if (store.state.user.permission.machinist || store.state.user.permission.production ||
        store.state.user.permission.outOfLine || store.state.user.permission.storage) {
        ToastHelper.workOrders.toastSynchronizedWorkOrders();
    }
});

workOrdersHub.on("RemindCleaning", () => {
    if (store.state.user.permission.outOfLine || store.state.user.permission.storage) {
        ToastHelper.workOrders.toastRemindCleaning();
    }
});

workOrdersHub.on("RemindCountPallets", () => {
    if (store.state.user.permission.outOfLine) {
        ToastHelper.workOrders.toastRemindCountPallets();
    }
});

workOrdersHub.on("RemindCountConsumables", () => {
    if (store.state.user.permission.outOfLine) {
        ToastHelper.workOrders.toastRemindCountConsumabled();
    }
});

workOrdersHub.on("WorkOrderCommentAdded", (workOrder: IWorkOrder) => {
    store.commit("productionLines/WORK_ORDER_UPDATED", workOrder);
    if (store.state.user.permission.machinist || store.state.user.permission.production ||
        store.state.user.permission.outOfLine || store.state.user.permission.storage) {
        ToastHelper.workOrders.toastWorkOrderCommentAdded(workOrder);
    }
});

export { workOrdersHub };
